import ServiceContainer from 'services/service-container';
import { apiClient } from 'services/api-client';
import { axiosClient, postConfigAxiosClient } from 'services/api-client/client';
import { configureCloudQueryClient } from '@env0/cloudquery-platform-client';
import omit from 'lodash/omit';

export const initializeStores = () => {
  const serviceContainer = new ServiceContainer(apiClient);
  postConfigAxiosClient(axiosClient, serviceContainer);

  configureCloudQueryClient({
    axiosInstance: axiosClient,
    getOrganizationId: () => serviceContainer.organizationsStore.currentOrganizationId
  });

  return omit(serviceContainer, 'apiClient') as Omit<ServiceContainer, 'apiClient'>;
};
